import { render, staticRenderFns } from "./image-previewer.vue?vue&type=template&id=35eb45b6&scoped=true"
import script from "./image-previewer.vue?vue&type=script&lang=js"
export * from "./image-previewer.vue?vue&type=script&lang=js"
import style0 from "./image-previewer.vue?vue&type=style&index=0&id=35eb45b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35eb45b6",
  null
  
)

export default component.exports